import { render, staticRenderFns } from "./ManageSummit.vue?vue&type=template&id=61261e22&scoped=true&"
import script from "./ManageSummit.vue?vue&type=script&lang=js&"
export * from "./ManageSummit.vue?vue&type=script&lang=js&"
import style0 from "./ManageSummit.vue?vue&type=style&index=0&id=61261e22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61261e22",
  null
  
)

export default component.exports